import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VDialog, {
    attrs: {
      "dark": _vm.UiTheme,
      "max-width": "1200px"
    },
    model: {
      value: _vm.fullScreenMap,
      callback: function ($$v) {
        _vm.fullScreenMap = $$v;
      },
      expression: "fullScreenMap"
    }
  }, [!_vm.isLoadingDevices && _vm.devicesMarkers.length ? _c('core-dtwin-map-header-map', {
    staticStyle: {
      "width": "100%",
      "height": "1000px"
    },
    attrs: {
      "geoCoordinates": _vm.devicesMarkers,
      "zoom": 2,
      "animateFlyIn": false,
      "spectrum": false,
      "interactiveMap": _vm.interactiveMap,
      "allowMultiCoordinates": "",
      "fullScreen": "",
      "fullScreenMap": _vm.fullScreenMap
    },
    on: {
      "close-expanded": function ($event) {
        _vm.fullScreenMap = false;
      }
    }
  }) : _vm._e()], 1), !_vm.isLoadingDevices && _vm.devicesMarkers.length ? _c('core-dtwin-map-header-map', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "geoCoordinates": _vm.devicesMarkers,
      "zoom": 2,
      "animateFlyIn": false,
      "spectrum": false,
      "interactiveMap": _vm.interactiveMap,
      "allowMultiCoordinates": ""
    },
    on: {
      "expand": function ($event) {
        _vm.fullScreenMap = true;
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };